import type { ColumnDef } from '@/components/ui';
import { DataTable, ErrorBanner, PageHeader, PageLoading } from '@/components/ui';
import { useApi } from '@/hooks/useApi';
import { sonarqubeApi } from '@/services/sonarqube-api';
import type { ISonarqubeProject } from '@skystone/shared';
import { buildRawColumns, buildStandardEmptyMessage, buildStandardTblSubtitle } from '@/lib/tbl-page-utils';
import { PageContainer } from '@/components/layout';

const sonarqubeProjectColumns: ColumnDef<ISonarqubeProject>[] = buildRawColumns<ISonarqubeProject>([
  { key: 'id', header: 'ID' },
  { key: 'projectKey', header: 'Project Key' },
  { key: 'projectName', header: 'Project Name' },
  { key: 'organization', header: 'Organization' },
  { key: 'repositoryId', header: 'Repository ID' },
  { key: 'productId', header: 'Product ID' },
  { key: 'fabricSynced', header: 'Fabric Synced' },
  { key: 'fabricSyncedAt', header: 'Fabric Synced At' },
  { key: 'createdAt', header: 'Created At' },
  { key: 'updatedAt', header: 'Updated At' },
]);

export function TblSonarqubeProjectsPage() {
  const { data: rows, loading, error } = useApi(() => sonarqubeApi.getProjects({ limit: 500 }), []);

  if (loading && !rows) return <PageLoading />;

  return (
    <PageContainer variant="wide" className="space-y-6">
      <PageHeader title="Tbl - raw_dim_sonarqube_project" subtitle={buildStandardTblSubtitle()} />
      <ErrorBanner message={error} />
      <DataTable
        data={rows ?? []}
        columns={sonarqubeProjectColumns}
        keyExtractor={(row) => row.id}
        enablePagination
        enableFilters
        emptyMessage={buildStandardEmptyMessage('sonarqube project')}
      />
    </PageContainer>
  );
}
